import {
  ExclamationTriangleIcon,
  InformationCircleIcon
} from "@heroicons/react/24/outline";
import { CSSProperties, FC, useId } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { cx } from "../../utils/classnames";

// Portalled to the body: dashboard cards animate with transforms, which trap an inline tooltip
// beneath the sticky header and the date picker no matter its z-index.
const InfoTip: FC<{
  text: string;
  className?: string;
  tone?: "info" | "warning";
}> = ({ text, className, tone = "info" }) => {
  const id = useId();
  const Icon =
    tone === "warning" ? ExclamationTriangleIcon : InformationCircleIcon;

  return (
    <>
      <Icon
        className={cx([
          "w-4 h-4 shrink-0 cursor-help",
          tone === "warning" ? "text-warning" : "text-neutral",
          className
        ])}
        strokeWidth={2}
        aria-label={text}
        data-tooltip-id={id}
        data-tooltip-content={text}
        data-tooltip-variant="dark"
      />
      {createPortal(
        <Tooltip
          id={id}
          className="z-50 max-w-[260px] !text-xs !font-normal !normal-case"
          style={{ "--rt-opacity": 1 } as CSSProperties}
        />,
        document.body
      )}
    </>
  );
};

export default InfoTip;
